<template>
    <div class="card card-graph flex-fill w-100">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h3 class="card-title mb-0">{{ title }}</h3>
            <router-link
                v-if="historyLink"
                :to="{ name: 'analytics-dashboard-component', params: { deviceId: devId, componentname: 'cpu-load' } }"
                class="btn btn-primary btn-sm d-flex align-items-center gap-1"
            >
                <i class="bx bx-history"></i>
                History
            </router-link>
        </div>
        <div class="card-body">
            <div class="d-flex flex-wrap flex-col justify-content-center">
                <GraphCpuLoad v-for="(term, idx) in terms" :key="idx" :host="host" :term="term" :cpu-count="cpuCount" :refresh="refreshInterval" :type="type"  />
            </div>
        </div>
    </div>
</template>

<script>
import GraphCpuLoad from "@/components/graphs/Graph.Cpu.Load.vue";

export default {
    name: 'GraphCpuLoadSet',
    props: {
        host: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        terms: {
            type: Array,
            default: function() {
                return ['shortterm']
            }
        },
        refreshInterval: {
            type: Number,
            default: 15
        },
        title: {
            type: String,
            default: 'CPU Loads'
        },
        cpuCount: {
            type: Number,
            default: 4
        },
        devId: {
            type: [String, Number],
            default: 0
        },
        historyLink: {
            type: Boolean,
            default: false
        }
    },
    components: {
        GraphCpuLoad,
    },
    setup() {}
};
</script>